<template>
<!-- Remember to include jQuery :) -->

  <div class="hello">

				   <div style="text-align: center;">
<!-- <script language="JavaScript">


</script> -->




<div id="count">보물상자 오픈까지 
	<span style="font-size: 24px; font-weight: 600; color: #f3ae03;" id="counter1">{{ timer.hour }}</span>시간<span id="counter2" style="font-size: 24px; font-weight: 600; color: #f3ae03;">{{ timer.minute }}</span>분<span id="counter3" style="font-size: 24px; font-weight: 600; color: #f3ae03;">{{ timer.second }}</span>초 남았습니다.<span style="padding-left:30px;"></span></div>



<!-- <script>getTime()</script>					    -->
					   
		<img src="https://www.useschool.co.kr/img/event_box.png" style="width: 40%; ">	 
						   </div>
		
<div style="clear: both"></div>

<div style="text-align:center;">		<button type="button" class="btn btn-warning btn-lg" @click="openBox()">보물상자 오픈</button></div>
		  </div>

  
</template>

<script>
import axios from 'axios';
export default {
  name: 'home',
  methods: {
    openBox(){
                axios.get(this.$parent.persistent.apiUrl + 'openBox.php?uid=' + this.$parent.loginID)
        .then(response => {
            // console.log(response.data)
            // this.items = response.data.items
            if(response.data.status == "error"){
              this.$parent.alert(response.data.reason)
            } else {
              this.$parent.alert(response.data.message)
              this.$parent.fetchMyInfo()
            }
        }).catch((error) => console.log(error));
    }
},
  mounted(){
    

setInterval(() => {


let days = this.$parent.myInfo.box.remainTime  / 60 / 60 / 24; 
let daysRound = Math.floor(days); 
let hours = this.$parent.myInfo.box.remainTime / 60 / 60 - (24 * daysRound); 
let hoursRound = Math.floor(hours); 
let minutes = this.$parent.myInfo.box.remainTime /60 - (24 * 60 * daysRound) - (60 * hoursRound); 
let minutesRound = Math.floor(minutes); 
let seconds = this.$parent.myInfo.box.remainTime - (24 * 60 * 60 * daysRound) - (60 * 60 * hoursRound) - (60 * minutesRound); 
let secondsRound = Math.round(seconds);

this.timer.hour = hoursRound;
this.timer.minute = minutesRound;
this.timer.second = secondsRound;


}, 1000)

},

data(){
  return {
    timer: {
        hour: 0,
        minute: 0,
        second: 0
    },
    time: 0
  }
}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


/*타임*/
#count {
 height: 147px;
 color: #fff;
 
 padding-top:60px;
 background-repeat: no-repeat;
}
#bt {
 height: 16px;
 width: 49;
 padding-left: 100px;
 padding-top: 0px;
}
</style>
